import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';

const VOICES = [['female', 'Женский'], ['male', 'Мужской'], ['duet', 'Дуэт']];
const SM_TR = {
  ru: { longVersion: 'Длинная версия', shortVersion: 'Короткая версия', yourVersion: 'Ваша версия', songToWord: 'Песня к слову', showText: 'показать текст', hideText: 'скрыть текст', downloadSong: 'Скачать песню', addLink: 'Добавить ссылку', editLink: 'Изменить ссылку', linkTitle: 'Ссылка на YouTube или TikTok', linkPh: 'Вставь ссылку…', linkOnly: 'Только ссылка на YouTube или TikTok', linkOwner: 'Только заказчик песни может добавить ссылку', linkFail: 'Не удалось сохранить', save: 'Сохранить', cancel: 'Отмена', style2: 'Второй стиль', noSecond: 'Без второго' },
  en: { longVersion: 'Long version', shortVersion: 'Short version', yourVersion: 'Your version', songToWord: 'Song for the word', showText: 'show lyrics', hideText: 'hide lyrics', downloadSong: 'Download song', addLink: 'Add link', editLink: 'Edit link', linkTitle: 'YouTube or TikTok link', linkPh: 'Paste a link…', linkOnly: 'Only a YouTube or TikTok link', linkOwner: 'Only the song owner can add a link', linkFail: 'Could not save', save: 'Save', cancel: 'Cancel', style2: 'Second style', noSecond: 'None' },
  uk: { longVersion: 'Довга версія', shortVersion: 'Коротка версія', yourVersion: 'Твоя версія', songToWord: 'Пісня до слова', showText: 'показати текст', hideText: 'сховати текст', downloadSong: 'Завантажити пісню', addLink: 'Додати посилання', editLink: 'Змінити посилання', linkTitle: 'Посилання на YouTube або TikTok', linkPh: 'Встав посилання…', linkOnly: 'Лише посилання на YouTube або TikTok', linkOwner: 'Лише замовник пісні може додати посилання', linkFail: 'Не вдалося зберегти', save: 'Зберегти', cancel: 'Скасувати', style2: 'Другий стиль', noSecond: 'Без другого' },
  de: { longVersion: 'Lange Version', shortVersion: 'Kurze Version', yourVersion: 'Deine Version', songToWord: 'Lied zum Wort', showText: 'Text anzeigen', hideText: 'Text ausblenden', downloadSong: 'Lied herunterladen', addLink: 'Link hinzufügen', editLink: 'Link ändern', linkTitle: 'YouTube- oder TikTok-Link', linkPh: 'Link einfügen…', linkOnly: 'Nur ein YouTube- oder TikTok-Link', linkOwner: 'Nur der Besteller darf einen Link hinzufügen', linkFail: 'Konnte nicht speichern', save: 'Speichern', cancel: 'Abbrechen', style2: 'Zweiter Stil', noSecond: 'Ohne' },
  es: { longVersion: 'Versión larga', shortVersion: 'Versión corta', yourVersion: 'Tu versión', songToWord: 'Canción para la palabra', showText: 'mostrar letra', hideText: 'ocultar letra', downloadSong: 'Descargar canción', addLink: 'Añadir enlace', editLink: 'Editar enlace', linkTitle: 'Enlace de YouTube o TikTok', linkPh: 'Pega un enlace…', linkOnly: 'Solo un enlace de YouTube o TikTok', linkOwner: 'Solo el autor de la canción puede añadir un enlace', linkFail: 'No se pudo guardar', save: 'Guardar', cancel: 'Cancelar', style2: 'Segundo estilo', noSecond: 'Ninguno' },
  fr: { longVersion: 'Version longue', shortVersion: 'Version courte', yourVersion: 'Ta version', songToWord: 'Chanson pour le mot', showText: 'afficher les paroles', hideText: 'masquer les paroles', downloadSong: 'Télécharger la chanson', addLink: 'Ajouter un lien', editLink: 'Modifier le lien', linkTitle: 'Lien YouTube ou TikTok', linkPh: 'Colle un lien…', linkOnly: 'Uniquement un lien YouTube ou TikTok', linkOwner: 'Seul le commanditaire peut ajouter un lien', linkFail: 'Échec de l enregistrement', save: 'Enregistrer', cancel: 'Annuler', style2: 'Deuxième style', noSecond: 'Aucun' },
  no: { longVersion: 'Lang versjon', shortVersion: 'Kort versjon', yourVersion: 'Din versjon', songToWord: 'Sang til ordet', showText: 'vis tekst', hideText: 'skjul tekst', downloadSong: 'Last ned sang', addLink: 'Legg til lenke', editLink: 'Endre lenke', linkTitle: 'YouTube- eller TikTok-lenke', linkPh: 'Lim inn en lenke…', linkOnly: 'Kun en YouTube- eller TikTok-lenke', linkOwner: 'Bare bestilleren kan legge til en lenke', linkFail: 'Kunne ikke lagre', save: 'Lagre', cancel: 'Avbryt', style2: 'Andre stil', noSecond: 'Ingen' },
};
const MANNERS = [['sung', 'Поют'], ['recite', 'Стихи под музыку']];
const STYLES = [['pop', 'Поп'], ['acoustic', 'Акустика'], ['rap', 'Рэп'], ['lullaby', 'Колыбельная'], ['rock', 'Рок'], ['folk', 'Фолк'], ['reggae', 'Регги'], ['hit', 'Хит'], ['electro', 'Электро'], ['depeche', 'Depeche Mode'], ['nordic', 'Скандинавские мотивы']];
const MOODS = [['happy', 'Весёлое'], ['calm', 'Спокойное'], ['energetic', 'Энергичное'], ['dreamy', 'Мечтательное'], ['epic', 'Эпичное']];
const TEMPOS = [['slow', 'Медленный'], ['medium', 'Средний'], ['fast', 'Быстрый']];

function parseLyrics(text, recite = false) {
  const items = [];
  (text || '').split('\n').forEach((ln) => {
    const s = ln.trim();
    if (!s) return;
    if (/^\[\[.*\]\]$/.test(s)) return;
    const m = s.match(/^\[(\d+(?:\.\d+)?)?\s*:[^\]]*\]\s*(.*)$/);
    if (m) {
      const start = (m[1] != null && m[1] !== '') ? parseFloat(m[1]) : null;
      const txt = (m[2] || '').trim();
      if (txt) items.push({ start, text: txt });
    } else {
      items.push({ start: null, text: s });
    }
  });
  const n = items.length;
  if (recite) {
    let cursor = 0;
    let started = false;
    for (let k = 0; k < n; k += 1) {
      if (items[k].start != null) { cursor = items[k].start; started = true; }
      items[k].start = started ? cursor : 0;
      const dur = Math.max(3.8, (items[k].text || '').length * 0.20);
      cursor += dur;
    }
    return items;
  }
  let i = 0;
  while (i < n) {
    if (items[i].start == null) { i += 1; continue; }
    let j = i + 1;
    while (j < n && items[j].start == null) j += 1;
    const startT = items[i].start;
    const span = j - i;
    const endT = j < n ? items[j].start : startT + span * 3.5;
    for (let k = 0; k < span; k += 1) {
      items[i + k].start = startT + ((endT - startT) * k) / span;
    }
    i = j;
  }
  for (let k = 0; k < n; k += 1) { if (items[k].start == null) items[k].start = 0; }
  return items;
}

function FilterRow({ label, opts, val, on, vals }) {
  const isOn = (v) => (vals ? vals.includes(v) : val === v);
  return (
    <div className="song-frow">
      <div className="song-frow-label">{label}</div>
      <div className="song-frow-opts">
        {opts.map(([v, t]) => (
          <button key={v} type="button" className={'song-check' + (isOn(v) ? ' song-check-on' : '')} onClick={() => on(v)}>
            <span className="song-check-dot" aria-hidden="true" />
            <span className="song-check-text">{t}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

function SongPlayer({ url, lyrics, label, slot, canModerate, onDelete, recite, accentColor, uiLang, wordNorm, songPos, mine, savedLink, userProfile, authHeaders }) {
  const smt = (k) => (SM_TR[uiLang] && SM_TR[uiLang][k]) || SM_TR.ru[k] || k;
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [link, setLink] = useState(savedLink || '');
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [linkInput, setLinkInput] = useState('');
  const [linkErr, setLinkErr] = useState('');
  const linkKind = /tiktok\.com/i.test(link) ? 'tiktok' : (/youtu\.?be|youtube\.com/i.test(link) ? 'youtube' : '');
  const [curLine, setCurLine] = useState(-1);
  const audioRef = useRef(null);
  const boxRef = useRef(null);
  const lines = parseLyrics(lyrics);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const t = window.setTimeout(() => setMenuOpen(false), 10000);
    return () => window.clearTimeout(t);
  }, [menuOpen]);

  useEffect(() => {
    const box = boxRef.current;
    if (!box || !open || curLine < 0) return;
    const el = box.children[curLine];
    if (!el) return;
    const boxRect = box.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const delta = (elRect.top - boxRect.top) - (box.clientHeight / 2 - el.clientHeight / 2);
    box.scrollTo({ top: Math.max(0, box.scrollTop + delta), behavior: 'smooth' });
  }, [curLine, open]);

  const onTime = () => {
    const a = audioRef.current; if (!a || !lines.length) return;
    const t = a.currentTime;
    const lastStart = lines[lines.length - 1].start || 0;
    let i = -1;
    if (lastStart <= 0.01 && a.duration && isFinite(a.duration)) {
      i = Math.min(lines.length - 1, Math.floor((t / a.duration) * lines.length));
    } else {
      for (let k = 0; k < lines.length; k += 1) { if (lines[k].start != null && lines[k].start <= t + 0.15) i = k; }
    }
    if (i !== curLine) setCurLine(i);
  };

  const [playing, setPlaying] = useState(false);
  const [cur, setCur] = useState(0);
  const [dur, setDur] = useState(0);
  const [muted, setMuted] = useState(false);
  const fmtTime = (s) => { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
  const togglePlay = () => { const a = audioRef.current; if (!a) return; if (a.paused) a.play(); else a.pause(); };
  const onLoaded = () => { const a = audioRef.current; if (a && isFinite(a.duration)) setDur(a.duration); };
  const onTimeFull = () => { const a = audioRef.current; if (a) setCur(a.currentTime || 0); onTime(); };
  const onSeek = (e) => { const a = audioRef.current; const v = Number(e.target.value); if (a) a.currentTime = v; setCur(v); };
  const toggleMute = () => { const a = audioRef.current; if (!a) return; a.muted = !a.muted; setMuted(a.muted); };
  const saveLink = async () => {
    const v = (linkInput || '').trim();
    if (v && !/youtube\.com|youtu\.be|tiktok\.com/i.test(v)) { setLinkErr(smt('linkOnly')); return; }
    try {
      const r = await fetch('/api/ai/song-link', { method: 'POST', headers: await authHeaders(), body: JSON.stringify({ word: wordNorm, pos: songPos, scope: slot, link: v, user: userProfile.id }) });
      const j = await r.json();
      if (j && j.ok) { setLink(v); setShowLinkModal(false); setLinkErr(''); }
      else { setLinkErr(j && j.error === 'not_owner' ? smt('linkOwner') : smt('linkFail')); }
    } catch (e) { setLinkErr(smt('linkFail')); }
  };
  const dl = async () => {
    setMenuOpen(false);
    const fname = ((wordNorm || 'song').trim() || 'song') + '.mp3';
    try {
      const r = await fetch(url);
      const b = await r.blob();
      if (window.showSaveFilePicker) {
        try {
          const handle = await window.showSaveFilePicker({ suggestedName: fname, types: [{ description: 'MP3', accept: { 'audio/mpeg': ['.mp3'] } }] });
          const w = await handle.createWritable();
          await w.write(b);
          await w.close();
          return;
        } catch (e) { if (e && e.name === 'AbortError') return; }
      }
      const u = URL.createObjectURL(b);
      const a = document.createElement('a');
      a.href = u; a.download = fname; a.click();
      URL.revokeObjectURL(u);
    } catch (e) { window.open(url, '_blank'); }
  };
  const pct = dur ? (cur / dur) * 100 : 0;

  return (
    <div className="song-player">
      <div className={'song-phead' + (lines.length ? ' song-phead-clickable' : '')} onClick={() => lines.length && setOpen((o) => !o)}>
        <span className="song-plabel">{label}</span>
        {lines.length > 0 && (
          <span className="song-toggle">{open ? ('▾ ' + smt('hideText')) : ('▸ ' + smt('showText'))}</span>
        )}
        {url && (
          <div className="song-menu-wrap" onClick={(e) => e.stopPropagation()}>
            {link && linkKind && (
              <a href={link} target="_blank" rel="noopener noreferrer" className={"song-link-icon song-link-" + linkKind} onClick={(e) => e.stopPropagation()} aria-label={linkKind} title={link}>
                {linkKind === 'youtube' ? (
                  <svg viewBox="0 0 28 20" width="28" height="20" aria-hidden="true"><rect x="0.5" y="0.5" width="27" height="19" rx="5" fill="#ff0000"/><path d="M11 6 L20 10 L11 14 Z" fill="#fff"/></svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M16.5 3c.3 2.1 1.5 3.4 3.5 3.7v2.4c-1.2.1-2.3-.2-3.5-.8v5.8c0 3.6-2.6 5.9-5.8 5.9C7.5 22 5 19.7 5 16.6c0-3 2.3-5.3 5.3-5.3.3 0 .6 0 .9.1v2.6c-.3-.1-.6-.2-.9-.2-1.5 0-2.7 1.2-2.7 2.8 0 1.6 1.2 2.8 2.6 2.8 1.5 0 2.7-1.1 2.7-3V3h1.6z"/></svg>
                )}
              </a>
            )}
            <button type="button" className="song-menu-btn" onClick={() => setMenuOpen((o) => !o)} aria-label="Параметры">⋮</button>
            {menuOpen && (
              <div className="song-menu">
                <button type="button" className="song-menu-item" onClick={dl}>{smt('downloadSong')}</button>
                {mine && (<button type="button" className="song-menu-item" onClick={() => { setMenuOpen(false); setLinkInput(link || ''); setLinkErr(''); setShowLinkModal(true); }}>{link ? smt('editLink') : smt('addLink')}</button>)}
                {canModerate && onDelete && (
                  <button type="button" className="song-menu-item song-menu-danger" onClick={() => { setMenuOpen(false); onDelete(slot); }}>Удалить песню</button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <audio ref={audioRef} src={url} preload="none" className="song-audio-native" onTimeUpdate={onTimeFull} onLoadedMetadata={onLoaded} onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)} />
      <div className="song-ctl">
        <button type="button" className={"song-ctl-play" + (playing ? " is-playing" : "")} style={playing && accentColor ? { background: accentColor } : undefined} onClick={togglePlay} aria-label={playing ? "Пауза" : "Играть"}>{playing ? (<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>) : (<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M9 6 L19 12 L9 18 Z" /></svg>)}</button>
        <span className="song-ctl-time">{fmtTime(cur)}</span>
        <input type="range" className="song-ctl-seek" min="0" max={dur || 0} step="0.1" value={cur} onChange={onSeek} aria-label="Перемотка" style={{ background: "linear-gradient(to right, #8b5cf6 " + pct + "%, rgba(139,92,246,.22) " + pct + "%)" }} />
        <span className="song-ctl-time">{fmtTime(dur)}</span>
        <button type="button" className="song-ctl-mute" onClick={toggleMute} aria-label="Звук">{muted ? "🔇" : "🔊"}</button>
      </div>
      {open && lines.length > 0 && (
        <div className="song-lyrics" ref={boxRef}>
          {lines.map((l, i) => (
            <div key={i} className={'song-line' + (i === curLine ? ' song-line-active' : '')}>{l.text}</div>
          ))}
        </div>
      )}
      {showLinkModal && (
        <div className="song-link-modal" onClick={() => setShowLinkModal(false)}>
          <div className="song-link-card" onClick={(e) => e.stopPropagation()}>
            <h4 className="song-link-h">{smt('linkTitle')}</h4>
            <input type="url" value={linkInput} onChange={(e) => { setLinkInput(e.target.value); setLinkErr(''); }} placeholder={smt('linkPh')} className="song-link-input" autoFocus />
            {linkErr && <p className="song-link-err">{linkErr}</p>}
            <div className="song-link-actions">
              <button type="button" className="song-link-cancel" onClick={() => setShowLinkModal(false)}>{smt('cancel')}</button>
              <button type="button" className="song-link-save" onClick={saveLink}>{smt('save')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function SongMaker({ word, wordNorm, data, userProfile, onPersonalCreated, accentColor, uiLang }) {
  const loggedIn = !!(userProfile && userProfile.id);
  const wn = (wordNorm || '').toLowerCase();
  const songPos = (data && (data.pos || data.type)) || '';
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [modal, setModal] = useState(null);
  const [filters, setFilters] = useState({ voice: 'female', style: 'pop', style2: '', mood: 'happy', tempo: 'medium', manner: 'sung' });
  const [full, setFull] = useState(true);
  const [customText, setCustomText] = useState('');
  const [showText, setShowText] = useState(false);
  const CUSTOM_MAX = 1000;
  const [extraHints, setExtraHints] = useState('');
  const smt = (k) => (SM_TR[uiLang] && SM_TR[uiLang][k]) || SM_TR.ru[k] || k;
  const [pendingDelete, setPendingDelete] = useState(null);
  const [showExtra, setShowExtra] = useState(false);
  const [extraLock, setExtraLock] = useState(false);

  const authHeaders = async () => {
    let token = '';
    try { const { data: s } = await supabase.auth.getSession(); token = (s && s.session && s.session.access_token) || ''; } catch (_) {}
    return Object.assign({ 'Content-Type': 'application/json' }, token ? { Authorization: 'Bearer ' + token } : {});
  };

  const loadState = async () => {
    try {
      if (loggedIn) {
        const res = await fetch('/api/ai/song-state', { method: 'POST', headers: await authHeaders(), body: JSON.stringify({ word, pos: songPos, user: userProfile.id }) });
        const j = await res.json().catch(() => null);
        if (j && j.ok) setState(j);
      } else {
        const res = await fetch('/api/ai/songs?word=' + encodeURIComponent(wn) + '&pos=' + encodeURIComponent(songPos));
        const j = await res.json().catch(() => null);
        if (j && j.ok) setState({ slots: j.slots || {}, can: {}, guest: true });
      }
    } catch (_) {}
  };

  useEffect(() => { if (wn) loadState(); /* eslint-disable-next-line */ }, [wn]);

  const openCreate = (intent, lenMode) => {
    if (lenMode === 'fixed-full') setFull(true);
    else if (lenMode === 'fixed-short') setFull(false);
    setErr('');
    setModal({ intent, lenMode });
  };

  const limitMsg = (j) => {
    if (j && j.role === 'free') return 'Лимит на сегодня исчерпан. Можно продолжить завтра (через сутки).';
    return 'Лимит 10 песен в сутки исчерпан. Можно продолжить завтра.';
  };
  const conflictMsg = (j) => {
    const r = j && j.error;
    if (r === 'slot_taken') return 'Эта версия песни уже создана.';
    if (r === 'already_personal') return 'Ваша личная версия уже есть.';
    if (r === 'author_no_personal') return 'Свою версию могут создавать только платные подписчики.';
    if (r === 'slots_open') return 'Сначала создаётся публичная версия.';
    return 'Сейчас создать нельзя.';
  };

  const create = async () => {
    const intent = (modal && modal.intent) || 'public';
    setModal(null); setBusy(true); setErr('');
    try {
      const res = await fetch('/api/ai/song', {
        method: 'POST',
        headers: await authHeaders(),
        body: JSON.stringify({ word, pos: songPos, user: userProfile.id, nick: (userProfile.nickname || ''), data: data || {}, filters, full, intent, custom_lyrics: customText.trim() || undefined, extra_hints: (canExtra && extraHints.trim()) ? extraHints.trim() : undefined }),
      });
      const j = await res.json().catch(() => null);
      if (res.status === 429) setErr(limitMsg(j));
      else if (res.status === 409) setErr(conflictMsg(j));
      else if (!res.ok || !j || !j.ok || !j.url) setErr('Не удалось создать песню. Попробуйте ещё раз.');
      else {
        if (intent === 'personal' && onPersonalCreated) {
          try { onPersonalCreated({ text: word, type: (data && (data.pos || data.type)) || '', data: data || {} }, { url: j.url, lyrics: j.lyrics || '', full: j.full, filters }); } catch (_) {}
        }
        await loadState();
      }
    } catch (e) { setErr('Сеть недоступна.'); }
    setBusy(false);
  };

  const deleteSong = (slot) => { setPendingDelete(slot); };
  const doDeleteSong = async () => {
    const slot = pendingDelete;
    setPendingDelete(null);
    if (!slot) return;
    setBusy(true); setErr('');
    try {
      const res = await fetch('/api/ai/song-delete', {
        method: 'POST',
        headers: await authHeaders(),
        body: JSON.stringify({ word, pos: songPos, user: userProfile.id, slot }),
      });
      const j = await res.json().catch(() => null);
      if (!res.ok || !j || !j.ok) setErr('Не удалось удалить песню.');
      else await loadState();
    } catch (e) { setErr('Сеть недоступна.'); }
    setBusy(false);
  };

  const canModerate = !!(state && (state.role === 'admin' || state.role === 'moderator'));
  const canExtra = !!(state && (['paid', 'admin', 'moderator'].includes(state.role) || state.paid));

  const slots = (state && state.slots) || {};
  const can = (state && state.can) || {};
  const sFull = slots.full;
  const sShort = slots.short;
  const anyPlayer = sFull || sShort || (state && state.personal);

  const createControls = () => {
    if (busy) return null;
    if (!loggedIn) return anyPlayer ? null : <p className="song-login-hint">Войдите, чтобы создать песню.</p>;
    const bothOpen = !sFull && !sShort;
    const oneOpen = (!sFull) !== (!sShort);
    if (bothOpen) {
      if (can.public_full || can.public_short) return <button type="button" className="btn-std song-create-btn" onClick={() => openCreate('public', 'choose')}>Создать песню</button>;
      return <p className="song-note">Лимит на сегодня исчерпан. Можно продолжить завтра.</p>;
    }
    if (oneOpen) {
      if (!sFull && can.public_full) return <button type="button" className="btn-std song-create-btn" onClick={() => openCreate('public', 'fixed-full')}>Создать дополнительную (длинную)</button>;
      if (!sShort && can.public_short) return <button type="button" className="btn-std song-create-btn" onClick={() => openCreate('public', 'fixed-short')}>Создать дополнительную (короткую)</button>;
      return <p className="song-note">Лимит на сегодня исчерпан. Можно продолжить завтра.</p>;
    }
    if (state && state.personal) return null;
    if (can.personal) return <button type="button" className="btn-std song-create-btn" onClick={() => openCreate('personal', 'choose')}>Создать свою версию</button>;
    if (state && state.has_personal) return <p className="song-note">Ваша личная версия уже создана.</p>;
    if (state && state.is_author && !state.paid) return <p className="song-note">Свою версию могут создавать только платные подписчики.</p>;
    return <p className="song-note">Лимит на сегодня исчерпан. Можно продолжить завтра.</p>;
  };

  return (
    <div className="songmaker">
      <div className="song-head">🎵 {smt('songToWord')}</div>
      {sFull && <SongPlayer key={sFull.url} url={sFull.url} lyrics={sFull.lyrics} recite={!!(sFull.filters && sFull.filters.manner === 'recite')} label={smt("longVersion")} slot="full" canModerate={canModerate} onDelete={deleteSong} accentColor={accentColor} uiLang={uiLang} wordNorm={wn} songPos={songPos} mine={!!sFull.mine} savedLink={sFull.link || ""} userProfile={userProfile} authHeaders={authHeaders} />}
      {sShort && <SongPlayer key={sShort.url} url={sShort.url} lyrics={sShort.lyrics} recite={!!(sShort.filters && sShort.filters.manner === 'recite')} label={smt("shortVersion")} slot="short" canModerate={canModerate} onDelete={deleteSong} accentColor={accentColor} uiLang={uiLang} wordNorm={wn} songPos={songPos} mine={!!sShort.mine} savedLink={sShort.link || ""} userProfile={userProfile} authHeaders={authHeaders} />}
      {state && state.personal && <SongPlayer key={state.personal.url} url={state.personal.url} lyrics={state.personal.lyrics} recite={!!(state.personal.filters && state.personal.filters.manner === 'recite')} label={smt("yourVersion")} uiLang={uiLang} slot="personal" wordNorm={wn} songPos={songPos} mine={true} savedLink={state.personal.link || ""} userProfile={userProfile} authHeaders={authHeaders} />}
      {!anyPlayer && !busy && <p className="song-empty-hint">Песни для этого слова ещё нет.</p>}
      {busy && (
        <div className="song-busy"><span className="song-spinner" /> Создаю песню… это займёт ~20–30 секунд</div>
      )}
      {createControls()}
      {err && <p className="song-err">{err}</p>}
      {modal && (
        <div className="song-modal" onClick={() => setModal(null)}>
          <div className="song-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="song-modal-title">Настройки песни</div>
            <FilterRow label="Голос" opts={VOICES} val={filters.voice} on={(v) => setFilters((f) => ({ ...f, voice: v }))} />
            <FilterRow label="Подача" opts={MANNERS} val={filters.manner} on={(v) => setFilters((f) => ({ ...f, manner: v }))} />
            <FilterRow label="Стиль (до 2)" opts={STYLES} vals={[filters.style, filters.style2].filter(Boolean)} on={(v) => setFilters((f) => { const sel = [f.style, f.style2].filter(Boolean); let next; if (sel.includes(v)) next = sel.filter((x) => x !== v); else if (sel.length < 2) next = [...sel, v]; else next = [sel[1], v]; return { ...f, style: next[0] || "pop", style2: next[1] || "" }; })} />

            <FilterRow label="Настроение" opts={MOODS} val={filters.mood} on={(v) => setFilters((f) => ({ ...f, mood: v }))} />
            <FilterRow label="Темп" opts={TEMPOS} val={filters.tempo} on={(v) => setFilters((f) => ({ ...f, tempo: v }))} />
            {modal.lenMode === 'choose' ? (
              <FilterRow label="Длина" opts={[['true', 'Полная'], ['false', 'Короткая']]} val={String(full)} on={(v) => setFull(v === 'true')} />
            ) : (
              <p className="song-modal-note">Длина: {full ? 'полная' : 'короткая'}</p>
            )}
            <div className="song-customtext-row">
              <button type="button" className="song-customtext-btn" onClick={() => setShowText(true)}>
                {customText.trim() ? '✍️ Свой текст добавлен' : '✍️ Добавить свой текст'}
              </button>
              {customText.trim() ? (
                <button type="button" className="song-customtext-clear" onClick={() => setCustomText('')}>убрать</button>
              ) : null}
            </div>
            <div className="song-customtext-row">
              <button type="button" className="song-customtext-btn" onClick={() => { if (canExtra) { setShowExtra(true); setExtraLock(false); } else { setExtraLock(true); } }}>
                {extraHints.trim() ? '⚙️ Доп. настройки ✓' : (canExtra ? '⚙️ Дополнительные настройки' : '⚙️ Дополнительные настройки 🔒')}
              </button>
              {canExtra && extraHints.trim() ? (
                <button type="button" className="song-customtext-clear" onClick={() => setExtraHints('')}>убрать</button>
              ) : null}
            </div>
            {extraLock && !canExtra ? (
              <p className="song-extra-lock">⭐ Доступно только платным пользователям.</p>
            ) : null}
            <div className="song-modal-actions">
              <button type="button" className="song-modal-cancel" onClick={() => setModal(null)}>Отмена</button>
              <button type="button" className="btn-std song-modal-go" onClick={create}>Создать</button>
            </div>
          </div>
        </div>
      )}
      {showText && (
        <div className="song-modal song-text-modal" onClick={() => setShowText(false)}>
          <div className="song-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="song-modal-title">Свой текст песни</div>
            <p className="song-text-hint">ИИ споёт ровно ваш текст. Лучше всего — на норвежском, короткими строками.</p>
            <textarea className="song-text-area" value={customText} maxLength={CUSTOM_MAX} onChange={(e) => setCustomText(e.target.value.slice(0, CUSTOM_MAX))} placeholder={'Напишите текст песни здесь...'} />
            <div className="song-text-counter">{customText.length} / {CUSTOM_MAX}</div>
            <div className="song-modal-actions">
              <button type="button" className="song-modal-cancel" onClick={() => { setCustomText(''); setShowText(false); }}>Очистить</button>
              <button type="button" className="btn-std song-modal-go" onClick={() => setShowText(false)}>Готово</button>
            </div>
          </div>
        </div>
      )}
      {showExtra && (
        <div className="song-modal song-text-modal" onClick={() => setShowExtra(false)}>
          <div className="song-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="song-modal-title">Дополнительные настройки</div>
            <p className="song-text-hint">До 5 акцентов через запятую — элементы, которые ИИ постарается добавить в музыку. Например: хор, эхо, свист, хлопки, струнные, орган, гитарное соло, детский голос, духовые.</p>
            <input type="text" className="song-extra-input" value={extraHints} onChange={(e) => setExtraHints(e.target.value)} placeholder="например: хор, эхо, струнные" />
            <p className="song-text-counter">{extraHints.split(',').map((s) => s.trim()).filter(Boolean).length} / 5 слов</p>
            <div className="song-modal-actions">
              <button type="button" className="song-modal-cancel" onClick={() => { setExtraHints(''); setShowExtra(false); }}>Очистить</button>
              <button type="button" className="btn-std song-modal-go" onClick={() => setShowExtra(false)}>Готово</button>
            </div>
          </div>
        </div>
      )}
      {pendingDelete && (
        <div className="song-modal song-text-modal" onClick={() => setPendingDelete(null)}>
          <div className="song-modal-card song-confirm-card" onClick={(e) => e.stopPropagation()}>
            <div className="song-modal-title">Удалить песню?</div>
            <p className="song-text-hint">Песня будет удалена из слова, слот освободится. Это действие нельзя отменить.</p>
            <div className="song-modal-actions">
              <button type="button" className="song-modal-cancel" onClick={() => setPendingDelete(null)}>Отмена</button>
              <button type="button" className="song-confirm-del" onClick={doDeleteSong}>Удалить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
